<template>
  <v-footer class="footer-color">
    <v-row no-gutters justify="center" align="center">
      <!-- <v-col cols="12" class="px-6">
                <v-row no-gutters>
                    <v-col cols="12" :lg="4" style="display: flex; align-items: center"
                           v-if="$vuetify.breakpoint.mdAndUp">
                        {{$t(`label.paymentMethod`)}}&nbsp;
                        <img src="/static/image/payment/payNow.png" width="200px"/>
                    </v-col>
                    <v-col cols="12" v-else>
                        <v-row>
                            <v-col cols="12" class="text-center">
                                {{$t(`label.paymentMethod`)}}
                            </v-col>
                        </v-row>
                        <v-row class="justify-center" align="center" no-gutters>
                            <v-col cols="12" :sm="2" class="mx-auto text-center">
                                <img src="/static/image/payment/payNow.png" width="200px"/>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="12" :lg="8" :align="$vuetify.breakpoint.mdAndUp? 'end' :'center'"
                           :class="$vuetify.breakpoint.mdAndUp? 'py-0': 'py-2'">
                        <img width="25" height="25" style="vertical-align: middle"
                             :src="`${mediaUrl}/footer_icons/eighteen.svg`" alt="18+"
                             title="18+"/>
                        <span class="px-4 navigator_active--text">Responsible Gaming</span>
                    </v-col>
                </v-row>

            </v-col> -->

      <v-col cols="12" :class="$vuetify.breakpoint.xsOnly ? 'px-3 py-4' : 'paddingLR py-4'">
        <div v-if="!$vuetify.breakpoint.smAndDown" class="dotted-line py-4"></div>
        <v-divider v-else class="footer-divider"></v-divider>
      </v-col>

      <v-row v-if="$vuetify.breakpoint.smOnly" no-gutters justify="space-between" :class="$vuetify.breakpoint.xsOnly ? 'px-1 pl-4' : 'px-1'">
        <v-col cols="12" :lg="7" :class="$vuetify.breakpoint.mdAndDown ? 'justify-center' : 'justify-start'">
          <template v-for="(link, index) in footerLink">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              color="white"
              :ripple="false"
              retain-focus-on-click
              exact-active-class
              :key="link.text_key"
              :to="{ name: link.routeName, params: { lang: $route.params.lang } }"
              text
              height="30"
              rounded
              class="my-0 mr-12 text-capitalize white--text px-3 footer"
            >
              <label class="footer-link-label text-decoration-underline subtitle-1">{{ $t(`label.${link.text_key}`) }}</label>
            </v-btn>
            <v-btn
              v-if="$vuetify.breakpoint.xsOnly"
              color="white"
              :ripple="false"
              retain-focus-on-click
              exact-active-class
              :key="link.text_key"
              :to="{ name: link.routeName, params: { lang: $route.params.lang } }"
              text
              height="30"
              rounded
              class="my-0 text-capitalize white--text pr-3 pl-1 footer"
            >
              <label class="footer-link-label text-decoration-underline caption">{{ $t(`label.${link.text_key}`) }}</label>
            </v-btn>
          </template>
        </v-col>
      </v-row>
      <v-row v-if="!$vuetify.breakpoint.smAndDown" no-gutters justify="space-between" :class="$vuetify.breakpoint.xsOnly ? 'px-1 pl-4' : 'px-1 pb-4'">
        <v-col cols="6" class="paddingLR">
          <v-row no-gutters>
            <h3 class="main_title">{{ $t(`footer.aboutDhoni`) }}</h3>
          </v-row>
          <v-row no-gutters class="pt-3">
            <p class="seo_text">{{ $t(`footer.aboutDhoniDescription`) }}</p>
          </v-row>
        </v-col>
        <v-col cols="6" class="pt-5 px-5">
          <v-row no-gutters>
            <p class="main_title">{{ $t(`label.responsibleGaming`) }}</p>
          </v-row>
          <v-row no-gutters class="">
            <img class="footer-icon" src="/static/svg/btm-18+.svg" alt />
            <img class="footer-icon" src="/static/svg/btm-gamcare.svg" alt />
          </v-row>
        </v-col>
      </v-row>
      <v-col cols="12" class="paddingLR py-5">
        <div v-if="!$vuetify.breakpoint.smAndDown" class="dotted-line py-4"></div>
        <v-row v-if="$vuetify.breakpoint.mdAndUp" no-gutters justify="space-between">
          <v-col cols="6">
            <v-row no-gutters>
              <label class="subtitle-1 footer-link-label">
                <p class="main_title">{{ $t(`label.paymentMethod`) }}</p>
              </label>
            </v-row>
            <v-row no-gutters v-if="$vuetify.breakpoint.mdAndUp" class="d-flex align-center">
              <!--              <img class="mr-3" width="162" height="32" src="/static/image/footer/475047.png" alt />-->
              <v-row no-gutters class="d-flex align-center" v-if="currency.toLowerCase() === 'bdt'">
                <a>
                  <img class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_bkash_colour.svg" alt="bkash9" />
                </a>
                <a>
                  <img class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_nagad_colour.svg" alt="nagad" />
                </a>
                <a>
                  <img class="mr-4 mt-1 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_rocket_colour.svg" alt="rocket" />
                </a>
                <a>
                  <img class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_upay_colour.svg" alt="upay" />
                </a>
              </v-row>
              <v-row no-gutters class="d-flex align-center" v-else-if="currency.toLowerCase() === 'inr'">
                <a>
                  <img class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_paytm_colour.svg" alt="bkash9" />
                </a>
                <a>
                  <img class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_phonepe_colour.svg" alt="nagad" />
                </a>
                <a>
                  <img class="mr-4 mt-1 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_UPI_colour.svg" alt="rocket" />
                </a>
                <a>
                  <img class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_bankdeposit_colour.svg" alt="upay" />
                </a>
              </v-row>
              <v-row no-gutters class="d-flex align-center" v-else-if="currency.toLowerCase() === 'npr'">
                <a>
                  <img class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_connectIPS_colour.svg" alt="bkash9" />
                </a>
                <a>
                  <img class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_khaltiwallet_colour.svg" alt="nagad" />
                </a>
                <a>
                  <img class="mr-4 mt-1 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_esewa_colour.svg" alt="rocket" />
                </a>
                <a>
                  <img class="mr-4 mt-2 grayscale-on-hover" width="60px" src="/static/image/footer/icon_footer_bankdeposit2_colour.svg" alt="upay" />
                </a>
              </v-row>
              <!--              <img class="mr-3" width="100" height="32" src="/static/image/footer/gamingcuracao.png" alt />-->
            </v-row>
          </v-col>
          <v-col cols="6" class="px-5">
            <v-row no-gutters>
              <label class="subtitle-1 footer-link-label">
                <p class="main_title">{{ $t(`footer.followUs`) }}</p>
              </label>
            </v-row>
            <v-row no-gutters>
              <a :href="this.fblink" target="_blank">
                <img class="footer-icon grayscale-on-hover" src="/static/svg/hover_btm-fb.svg" alt />
              </a>
              <a :href="this.ytLink" target="_blank" @mouseenter="hoverYT = true" @mouseleave="hoverYT = false">
                <img class="footer-icon" :src="hoverYT ? '/static/svg/hover_btm-yt.svg' : '/static/svg/btm-yt.svg'" alt />
              </a>
              <!--              <a :href="this.ytLink" target="_blank">-->
              <!--                <img class="footer-icon grayscale-on-hover" src="/static/svg/hover_btm-yt.svg" alt />-->
              <!--              </a>-->
              <a :href="this.instaLink" target="_blank" v-if="this.currency == currenciesList.BDT">
                <img class="footer-icon grayscale-on-hover" src="/static/svg/hover_btm-ig.svg" alt />
              </a>
              <a :href="this.twtLink" target="_blank" @mouseenter="hoverX = true" @mouseleave="hoverX = false" v-if="this.currency == currenciesList.BDT">
                <img class="footer-icon" :src="hoverX ? '/static/svg/hover_btm-twitter.svg' : '/static/svg/btm-twitter.svg'" alt />
              </a>
              <a :href="this.tlgLink" target="_blank">
                <img class="footer-icon grayscale-on-hover" src="/static/svg/hover_btm-tlg.svg" alt />
              </a>
            </v-row>
          </v-col>
          <!--          <v-col cols="4">-->
          <!--            <v-row no-gutters>-->
          <!--              <label class="subtitle-1 footer-link-label"><p class="main_title">Responsible Games</p></label>-->
          <!--            </v-row>-->
          <!--            <v-row no-gutters>-->
          <!--              <img class="footer-icon" src="/static/svg/btm-18.svg" alt />-->
          <!--            </v-row>-->
          <!--          </v-col>-->
        </v-row>
        <v-row no-gutters v-if="$vuetify.breakpoint.mdAndUp" class="mt-12 align">
          {{ footerCopyRight }}
        </v-row>
        <!--        <v-divider class="footer-divider"></v-divider>-->
        <v-row no-gutters v-show="!isViewableAll && $vuetify.breakpoint.smAndDown">
          <v-col cols="12" :lg="4">
            <!-- <v-row>
                            <v-col cols="12" class="text-decoration-underline pt-0">
                                <v-btn text @click="isViewableAll = true" class="font-weight-bold">
                                    Understand more
                                </v-btn>
                            </v-col>
                        </v-row> -->
          </v-col>
        </v-row>
      </v-col>
      <v-row no-gutters v-show="$vuetify.breakpoint.mdAndUp || isViewableAll" class="py-6 paddingLR second_footer">
        <v-col cols="12">
          <h1 class="pb-2">
            {{ $t(`footer.trustedPremiumOnlineCasinoTitle`) }}
          </h1>
          <p class="seo_text">{{ $t(`footer.trustedPremiumOnlineCasinoDesc_1`) }}</p>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="12">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h2 class="pb-2">
                {{ $t(`footer.gameAvailable`) }}
              </h2>
              <p class="seo_text">{{ $t(`footer.gameAvailableDescription`) }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.cricketBetting`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.cricketBettingDes`) }}
              </p>
            </v-col>
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.slotGames`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.slotGamesDes`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.sportsBetting`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.sportsBettingDes`) }}
              </p>
            </v-col>
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.crashGames`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.crashGamesDes`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.liveCasino`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.liveCasinoDes`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="12">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h2 class="pb-2">
                {{ $t(`footer.24/7support`) }}
              </h2>
              <p class="seo_text">{{ $t(`footer.24/7supportDes`) }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.mobileContact`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.mobileContactDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.email`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.emailDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.liveChat`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.liveChatDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="12">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h2 class="pb-2">
                {{ $t(`footer.signUp`) }}
              </h2>
              <p class="seo_text">{{ $t(`footer.signUpDesc`) }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.howToSignUp`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.howToSignUpDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.loginProcess`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.loginProcessDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.howToLogin`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.howToLoginDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="12">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h2 class="pb-2">
                {{ $t(`footer.securityAndCompliance`) }}
              </h2>
              <p class="seo_text">{{ $t(`footer.securityAndComplianceDesc`) }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="12">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.casinoIGamingLicensing`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.casinoIGamingLicensingDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="12">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h2 class="pb-2">
                {{ $t(`footer.bonusesAndPromotions`) }}
              </h2>
              <p class="seo_text">{{ $t(`footer.bonusesAndPromotionsDesc`) }}</p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="6">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.welcomeBonuses`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.welcomeBonusesDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="6">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.reloadWeeklyPromotions`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.reloadWeeklyPromotionsDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="12">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h2 class="pb-2">
                {{ $t(`footer.paymentOptions`) }}
              </h2>
              <p class="seo_text">
                {{ $t(`footer.paymentOptionsDes`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.nagad`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.nagadDesc`) }}
              </p>
            </v-col>
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.upay`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.upayDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.rocket`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.rocketDesc`) }}
              </p>
            </v-col>
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.bankTransfer`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.bankTransferDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="4">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h3 class="main_title pb-2">
                {{ $t(`footer.bkash`) }}
              </h3>
              <p class="seo_text">
                {{ $t(`footer.bkashDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="12">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h2 class="pb-2">
                {{ $t(`footer.mobileApp`) }}
              </h2>
              <p class="seo_text">
                {{ $t(`footer.mobileAppDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="showMore" cols="12" :lg="12">
          <v-row class="mt-2">
            <v-col cols="10" :class="$vuetify.breakpoint.mdAndUp ? 'py-2' : 'mx-auto text-center'">
              <h2 class="pb-2">
                {{ $t(`footer.referralProgram`) }}
              </h2>
              <p class="seo_text">
                {{ $t(`footer.referralProgramDesc`) }}
              </p>
            </v-col>
          </v-row>
        </v-col>

        <label @click="showMore = !showMore" v-if="!showMore" class="readMore">{{ $t(`footer.readMore`) }}</label>
        <label @click="showMore = !showMore" v-if="showMore" class="readMore">{{ $t(`footer.readLess`) }}</label>
      </v-row>
      <v-col cols="12" class="px-5" v-if="!$vuetify.breakpoint.mdAndUp">
        <v-row no-gutters justify="space-between">
          <v-col cols="6" :lg="4">
            <v-row no-gutters>
              <label class="subtitle-1 footer-link-label">Responsible Games</label>
            </v-row>
            <v-row no-gutters>
              <img class="footer-icon" src="/static/svg/btm-18.svg" alt />
            </v-row>
          </v-col>
          <v-col cols="6" :lg="4">
            <v-row no-gutters>
              <label class="subtitle-1 footer-link-label">{{ $t(`label.certifiedBy`) }}</label>
            </v-row>
            <v-row no-gutters v-if="$vuetify.breakpoint.mdAndUp">
              <a href="https://dhoni88official.com/get-started/" target="_blank">
                <img class="mr-3 mt-1" width="200px" src="/static/svg/logo.svg" alt />
              </a>
            </v-row>
            <v-row no-gutters v-if="$vuetify.breakpoint.smAndDown">
              <a :href="this.casinolink" target="_blank">
                <img class="mr-3 mt-1" width="132px" src="/static/svg/logo.svg" alt />
              </a>
            </v-row>
          </v-col>
          <v-col cols="12" :lg="4">
            <v-row no-gutters>
              <label class="subtitle-1 footer-link-label">Find Us</label>
            </v-row>
            <v-row no-gutters>
              <a :href="this.fblink" target="_blank">
                <img class="footer-icon" src="/static/svg/btm-fb.svg" alt />
              </a>
              <a :href="this.instaLink" target="_blank" v-if="this.currency == currenciesList.BDT">
                <img class="footer-icon" src="/static/svg/btm-insta.svg" alt />
              </a>
              <a :href="this.twtLink" target="_blank" v-if="this.currency == currenciesList.BDT">
                <img class="footer-icon" src="/static/svg/btm-twitter.svg" alt />
              </a>
              <a :href="this.ytLink" target="_blank">
                <img class="footer-icon" src="/static/svg/btm-yt.svg" alt />
              </a>
              <a :href="this.tlgLink" target="_blank">
                <img class="footer-icon" src="/static/svg/btm-tlg.svg" alt />
              </a>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col v-if="!$vuetify.breakpoint.mdAndUp" class="px-5 mt-12 align" cols="12" :class="$vuetify.breakpoint.mdAndUp ? 'pr-4' : 'pr-4 py-2'">
        {{ footerCopyRight }}
      </v-col>
      <!-- <v-col cols="12" class="px-6 py-4">
                <v-divider class="title_color"></v-divider>
            </v-col> -->
      <!-- <v-col cols="12" class="px-8 mx-0">
                <v-row :justify="$vuetify.breakpoint.mdAndUp? 'start' :'center'" no-gutters>
                    <v-col cols="12" class="shrink footer-vendor-box-col">
                        <div>
                            <label class="white--text footer-box-title">{{ $t(`label.poweredBy`) }}:</label>
                        </div>
                        <div class="footer-vendor-box">
                            <template v-for="(k, i) in footerProvider">
                                <img class="footer-image"
                                     :src="`${mediaUrl}/footer_icons/${k}_footer.png`" alt
                                     :key="i"/>
                            </template>
                        </div>
                    </v-col>
                </v-row>
                <v-row :justify="$vuetify.breakpoint.mdAndUp? 'space-between' :'center'" no-gutters>
                    <v-col cols="auto" class="shrink footer-license-box-col">
                        <div>
                            <label class="white--text footer-box-title">{{ $t(`label.license`) }}:</label>
                        </div>
                        <div class="text-center">
                            <img class="footer-image license" src="/static/image/license/first-cagayan.png"
                                 @click="goToFirstCagayan"/>
                            <img class="footer-image license" src="/static/image/license/pagcor.png"
                                 @click="goToPagcor"/>
                        </div>
                    </v-col>
                    <v-col cols="auto" class="shrink footer-language-box-col">
                        <div class="text-center">
                            <label class="white--text footer-box-title">{{ $t(`label.language`) }}:</label>
                        </div>
                        <div class="text-center">
                            <img @click="changeLanguage(language)" v-for="language in supportedLanguage" :key="language"
                                 class="footer-image language" :src="`/static/image/country/${language}.png`" alt/>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" :class="$vuetify.breakpoint.smAndDown ? 'mx-auto justify-center' : ''">
                        <v-img :src="`${mediaUrl}/ssl_cert.png`" :aspect-ratio="167/42" width="167"/>
                    </v-col>
                </v-row>
            </v-col> -->
    </v-row>
  </v-footer>
</template>

<script>
import NavOnePay from '@/assets/svg/onePay.svg'
import { ROUTE_NAME } from '@/constants/route.constants'
import format from 'string-format'
import { locale, uiHelper } from '@/util'
import { SHARED, CACHE_KEY, Currencies } from '@/constants/constants'
import { SHARED_LOADING } from '@/store/shared.module'
import _ from 'lodash'

export default {
  name: 'appFooter',
  props: {},
  components: {
    NavOnePay
  },
  data: () => ({
    showMore: false,
    hoverX: false,
    hoverYT: false,
    currenciesList: Currencies,
    currency: uiHelper.getCurrency(),
    casinolink: uiHelper.getcasinoLink(),
    fblink: uiHelper.getFBLink(),
    instaLink: uiHelper.getInstaLink(),
    twtLink: uiHelper.getTwtLink(),
    ytLink: uiHelper.getYTLink(),
    tlgLink: uiHelper.getTlgLink(),
    isViewableAll: false,
    footerProvider: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_LIST_TYPE_NAME}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    mediaUrl: SHARED.MEDIA_SERVER_URL,
    supportedLanguage: SHARED.SUPPORTED_LANGUAGES,
    storageGameProviderType: uiHelper.getLocalStorage(`${CACHE_KEY.GAME_PROVIDER_TYPE}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`),
    footerLink: [
      // {
      //   link: '/customer-service',
      //   text: locale.getMessage(`label.customerService`)
      // },
      {
        routeName: ROUTE_NAME.TNC,
        text_key: 'termsAndConditions'
      },
      {
        routeName: ROUTE_NAME.ABOUT_US,
        text_key: 'aboutUs'
      },
      {
        routeName: ROUTE_NAME.FAQ,
        text_key: 'faq'
      },
      {
        routeName: ROUTE_NAME.CONTACT_US,
        text_key: 'contactUs'
      }
    ],
    footerCopyRight: format(locale.getMessage(`message.copyRight`), new Date().getFullYear())
  }),
  computed: {
    ProviderTypes() {
      return this.$store.state.game.ProviderTypes
    }
  },
  watch: {
    ProviderTypes() {
      this.footerProvider = uiHelper.getLocalStorage(`${CACHE_KEY.GAME_LIST_TYPE_NAME}_${uiHelper.getPlatform()}_${uiHelper.getCurrency()}`)
      return this.$store.state.game.ProviderTypes
    }
  },
  methods: {
    changeLanguage(language) {
      this.$store.dispatch(`${SHARED_LOADING}`)
      locale.setCurrentLanguage(language)
      uiHelper.removeCookie('language')
      uiHelper.setCookie('language', language)
      window.location.reload()
    },
    goToFirstCagayan() {
      window.open('https://www.firstcagayan.com/zh-hant#2', '_blank')
    },
    goToPagcor() {
      window.open('https://pagcor.ph/index.php', '_blank')
    }
  }
}
</script>

<style lang="scss">
.grayscale-on-hover:hover {
  filter: grayscale(0%);
}
.grayscale-on-hover {
  filter: grayscale(100%);
}
.readMore {
  color: #000000;
  text-decoration: underline;
}
.paddingLR {
  padding: 0 12% !important;
}
.second_footer {
  background-color: #F5F5F5;
  color: #000000;
}
.dotted-line {
  border-top: 1px dotted #FD8839; /* Adjust the color and thickness as needed */
  margin-top: 10px; /* Adjust the margin as needed */
}
.footer-divider {
  color: #3a3a3a;
}
.footer-icon {
  float: center;
  display: block;
  width: 50px;
  height: 50px;
  margin: 5px 12px 0px 0px;
}
.navPayIcon {
  width: 120px;
  height: 50px;
  margin-top: -15px;
  fill: #0f80aa;
}

.payNowIcon {
  width: 144px;
  height: 28px;
}

.main_title {
  font-size: 16px;
}

.seo_text {
  font-size: 14px;
}

.v-footer {
  min-height: 200px;
  background-color: #ebebeb;
  padding: 25px 0 0px;

  .footer-box-title {
    font-size: 18px;
    display: block;
    padding: 10px 0px;
  }

  .footer-link-label {
    color: #3a3a3a;
    letter-spacing: 0;
    cursor: pointer;

    &:hover {
      color: white;
    }
  }

  .footer-link-divider {
    border-color: #3a3a3a;
  }
}

.footer-row {
  padding-left: 65px;
  padding-right: 65px;

  &.col {
    padding: 0px 8px;
  }
}

.footer-image {
  margin-right: 15px;
  margin-bottom: 10px;
  height: 30px;

  &.language,
  &.license {
    cursor: pointer;
  }
}

.footer-color {
  background-color: white !important;
}

@media (max-width: 1650px) {
}

@media (max-width: 1500px) {
}

@media (max-width: 1350px) {
  .footer-box-title,
  .footer-link-label {
    font-size: 14px;
  }
}

@media (max-width: 1263px) {
  .footer-vendor-box-col {
    min-width: 90%;
    max-width: 90%;

    .footer-vendor-box {
      max-width: 100%;
    }
  }

  .footer-image {
    height: 25px;
  }
}

@media (max-width: 1024px) {
}

@media (max-width: 959px) {
}

@media (max-width: 599px) {
  .footer-icon {
    float: center;
    display: block;
    width: 30px;
    height: 30px;
    margin: 5px 12px 0px 0px;
  }
  .footer-box-title,
  .footer-link-label {
    font-size: 16px;
  }

  .footer-vendor-box-col {
    min-width: 90%;
    max-width: 90%;
    text-align: center;
  }
  .footer-transaction-method-box-col {
    min-width: 90%;
    max-width: 90%;
    text-align: center;
  }
  .footer-license-box-col {
    min-width: 90%;
    max-width: 90%;
    text-align: center;
  }
  .footer-language-box-col {
    min-width: 90%;
    max-width: 90%;
    text-align: center;
  }
}

@media (max-width: 425px) {
}
@media (min-width: 900px) {
  .footer-color {
    background-color: white !important;
  }
}
</style>
